import { z } from 'zod';
export const MediaScreenshotItemSchema = z.object({
    url: z.string(),
    label: z.string().nullish()
}).meta({
    id: 'MediaScreenshotItem'
});
export const MediaSchema = z.object({
    homepageScreenshotUrl: z.string().nullish(),
    screenshots: z.array(MediaScreenshotItemSchema).optional()
}).passthrough().meta({
    id: 'Media'
});

//# sourceMappingURL=media.schema.js.map